<template>
	<div v-if="success" class="mt-2 mb-4">
		<template v-if="sfa">
			<div>
				<h6><b>Vážený klient,</b></h6>
				pokyn bol zaevidovaný.
			</div>
		</template>

		<template v-else>
			<div v-if="today.getHours() < 16">
				Vážený klient, Váš pokyn bude zrealizovaný do dvoch hodín.
			</div>
			<div v-else>
				Vážený klient, Váš pokyn bude zrealizovaný nasledujúci pracovný deň.
			</div>
		</template>
	</div>
	<div v-else-if="status === 2">
		<div>
			<div class="mb-3" v-if="request.transactionType === 'buy'">
				<h6><b>Vážený klient,</b></h6>
				na Vašom portfóliu {{ this.request.strategyName }} nie je dostatok
				peňažných prostriedkov na realizáciu Vášho pokynu. Prosím upravte počet
				cenných papierov na nákup.
			</div>
			<div v-else>
				<h6><b>Vážený klient,</b></h6>
				na Vašom portfóliu {{ this.request.strategyName }} nie je dostatok
				cenných papierov na realizáciu Vášho pokynu. Prosím upravte počet
				cenných papierov na predaj.
			</div>
			<div class="text-center mt-4">
				<button type="submit" class="btn btn-warning w-50" @click="status = 0">
					Upraviť počet CP
				</button>
				<button
						class="btn btn-outline-warning w-50"
						@click="$parent.$parent.hide"
				>
					Nie
				</button>
			</div>
		</div>
	</div>
	<form
			v-else
			class="request-wrapper"
			ref="tradeForm"
			@submit.prevent="addNewTradeRequest()"
	>
		<div class="row">
			<div class="col-12">
				<div class="row">
					<b-form-group>
						<b-form-radio-group
								v-model="request.transactionType"
								:options="options"
								buttons
								button-variant="outline-warning"
								name="radio-btn-outline"
								class="w-100"
						></b-form-radio-group>
					</b-form-group>
				</div>
				<div class="row">
					<div class="col-4">Investičná stratégia:</div>
					<select
							class="col-8 form-control"
							v-model="request.strategy"
							required
					>
						<option :value="null">Vyberte investičnú stratégiu</option>
						<option
								v-for="(strategy, i) in request.transactionType === 'buy'
                ? buyStrategies
                : sellStrategies"
								:value="strategy.id"
								:key="i"
						>
							{{ strategy.name }}
						</option>
					</select>
				</div>
				<div class="row">
					<div class="col-4">Aktívum:</div>
					<select
							class="col-8 form-control"
							v-model="request.equity"
							@change="setEquity($event)"
							:disabled="!request.strategy"
					>
						<option value=""></option>
						<option
								v-for="(equity, i) in equities"
								v-bind:value="equity.id"
								:key="i"
						>
							{{ equity.name }}
						</option>
					</select>
				</div>
				<div class="row">
					<div class="col-4">ISIN:</div>
					<input
							class="col-8 form-control"
							type="text"
							:disabled="true"
							v-model="request.isin"
							:required="true"
					/>
				</div>
				<div class="row">
					<div class="col-4">Počet:</div>
					<input
							class="col-8 form-control"
							type="number"
							v-model="request.amount"
							:max="maxAmount"
							:disabled="!request.equity"
							:required="true"
					/>
				</div>
				<div class="row">
					<div class="col-4">Jednotková cena:</div>
					<input
							class="col-8 form-control"
							type="text"
							v-model="request.value"
							required
					/>
				</div>
				<div class="row">
					<div class="col-4">Platnosť pokynu:</div>
					<div class="col-8 px-0">
						<date-picker
								v-model="request.date"
								:min-date="minDate"
								:max-date="maxDate"
								:input-props="{
                placeholder: 'Vyberte dátum',
                class: 'form-control',
                required: true
              }"
						/>
					</div>
				</div>
				<div class="text-center mt-4">
					<button type="submit" class="btn btn-warning w-50">
						<font-awesome-icon
								v-if="loading"
								icon="spinner"
								class="ml-2"
								spin
						/>
						Odoslať
					</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
	name: "TradeForm",
	components: {
		DatePicker
	},
	created() {
		if (this.requestInfo.message) {
			this.request.message = this.requestInfo.message;
			this.disabled = this.requestInfo.disabled;
		}

		if (this.today.getHours() >= 16) {
			this.minDate.setDate(this.today.getDate() + 1);
			this.request.date.setDate(this.today.getDate() + 1);
		} else {
			this.minDate = this.today;
		}
		this.maxDate.setDate(this.minDate.getDate() + 30);
	},
	computed: {
		equities() {
			return this.$store.state.instructions.equities;
		},
		buyStrategies() {
			return this.$store.state.instructions.availableStrategies;
		},
		sellStrategies() {
			return this.$store.state.instructions.sellStrategies;
		},
		assignedToMe() {
			return this.$store.state.account.assignedToMe;
		},
		sfaInstruction() {
			return this.$store.state.instructions.sfaInstruction;
		},
	},
	watch: {
		"request.strategy"() {
			if (this.request.strategy) {
				this.loadEquities();
			}
		},
		"request.transactionType"() {
			if (this.sfaInstruction.length == 0) {
				this.request.strategy = this.request.equity = this.request.isin = this.request.amount = null;
			}
		},
	},
	methods: {
		loadEquities() {
			this.$store.dispatch("instructions/equities", {
				transactionType: this.request.transactionType,
				strategy: this.request.strategy
			});
		},
		addNewTradeRequest() {
			this.loading = true;
			if (this.today.getHours() >= 16) {
				if (this.request.date.getDate() === this.today.getDate() && this.request.date.getMonth() === this.today.getMonth()) {
					this.request.date.setDate(this.today.getDate() + 1);
				}
			}
			this.request.date.setHours(10);
			this.request.date.setMinutes(0);
			this.request.date.setSeconds(0);

			let requestName = "instructions/equityInstruction";

			if (this.assignedToMe.length > 0) {
				requestName = "instructions/equityInstructionSFA";
				this.sfa = true;
			}

			this.$store
					.dispatch(requestName, this.request)
					.then(() => {
						this.success = true;
						this.loading = false;

						if(this.$store.state.messages.item)
							this.$store.dispatch("messages/messageDetail", {
								id: this.request.predefinedMessage
							});
					})
					.catch(error => {
						this.status = error.response.data.result.accountStatus;
						this.loading = false;
					});
		},
		setEquity(event) {
			const result = this.equities.filter(equity => {
				return equity.id === parseInt(event.target.value);
			});
			if (result[0]) {
				this.request.isin = result[0].isin;
				this.maxAmount = result[0].amount;
			}
		},
		loadSfaInstruction() {
			if (this.sfaInstruction && this.sfaInstruction.transactionType != null) {
				this.request = {...this.sfaInstruction};
				this.request.date = new Date(this.request.date)
				this.setEquity({
					target: {
						value: this.sfaInstruction.equity,
					}
				});
				if(this.$store.state.messages.item)
					this.request.predefinedMessage = this.$store.state.messages.item.id;
				this.$store.commit('instructions/setSfaInstruction', {});
			}
		}
	},
	mounted() {
		this.loadSfaInstruction();
	},
	data() {
		return {
			today: new Date(),
			minDate: new Date(),
			maxDate: new Date(),
			request: {
				transactionType: this.requestInfo.isSale ? "sell" : "buy",
				equity: null,
				isin: null,
				amount: null,
				strategy: null,
				priceType: "market",
				value: null,
				message: null,
				currency: 1,
				date: new Date()
			},
			verification: {
				code: "",
				remember: true
			},
			options: [
				{text: "NÁKUP", value: "buy"},
				{text: "PREDAJ", value: "sell"}
			],
			success: false,
			status: 0,
			loading: false,
			disabled: false,
			maxAmount: null,
			sfa: false,
		};
	},
	props: {
		requestInfo: {
			type: Object,
			default: function () {
				return {
					isSale: true,
					code: ""
				};
			}
		}
	}
};
</script>
